import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 -960 960 960"

const RemoveIcon = createSvgIcon(
  <>
    <path d='M232-444v-72h496v72H232Z' />
  </>,
  'RemoveIcon'
)

export default RemoveIcon
